(function() {
    'use strict';
    
a3_cabin_reports.controller('TravelValueSealCtrl', TravelValueSealCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name TravelValueSealCtrl
    * @description 
    *  Manages Travel Value Seal Modal View
    * @ngInject
    */
function TravelValueSealCtrl($scope, $uibModalInstance, ModalDialogResultFactory, TravelValueSealFactory, tvs) {

		var result = ModalDialogResultFactory.createNew();

		if (tvs == null) {
			result.Object = TravelValueSealFactory.createNew();
			result.isInsertMode = true;
		} else {
			result.Object = TravelValueSealFactory.fromObject(tvs);
			result.isInsertMode = false;
		}

		$scope.tvs = result.Object;

		$scope.ok = ok; 
        $scope.cancel = cancel;
    
        /**
         * Close modal after u check Label
         * @memberof TravelValueSealCtrl
         */
        function ok() {
			if ((result.Object.Label == null) || (result.Object.Label == ''))
				result.Object.Label = '-';
			$uibModalInstance.close(result);
		}


        /**
         * Close modal 
         * @memberof TravelValueSealCtrl
         */    
        function cancel() {
			$uibModalInstance.close(null);
		}

	}

})();